import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useLocale } from '@/i18n/useLocale'
import { localePath, ROUTES } from '@/lib/routes'
import { useDocumentTitle } from '@/lib/seo'

export default function NotFound() {
  const { t } = useTranslation()
  const locale = useLocale()
  useDocumentTitle(`404 — ${t('site.name')}`)

  return (
    <section className="max-w-2xl mx-auto px-4 md:px-8 py-24 text-center">
      <h1 className="text-4xl font-bold">{t('notFound.title')}</h1>
      <Link
        to={localePath(locale, ROUTES.home)}
        className="inline-block mt-6 px-4 py-2 rounded-md bg-mono-800 text-mono-100
          dark:bg-mono-100 dark:text-mono-900 text-sm"
      >
        {t('notFound.back')}
      </Link>
    </section>
  )
}
